import {axiosGet} from "../../../app/Helpers/AxiosHelper";

const state = {
    clientUserList: [],
    currencyList: [],
};

const getters = {
    getClientUser: state => {
        return state.clientUserList
    },
    getCurrency: state => {
        return state.currencyList
    }
};

const actions = {
    getClientUser({commit}) {
        axiosGet('client-users').then(({data}) => {
            commit('CLIENT_USER_INFO', data)
        }).catch((error) => console.log(error));
    },
    getCurrency({commit}) {
        axiosGet('all-currency').then(({data}) => {
            commit('CURRENCY_INFO', data)
        }).catch((error) => console.log(error));
    }
};

const mutations = {
    CLIENT_USER_INFO(state, data) {
        state.clientUserList = data;
    },
    CURRENCY_INFO(state, data) {
        state.currencyList = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
